import styled from 'styled-components'
export const Container = styled.div`
  &.select-container {
    position: relative;
    padding: 5px 0;
    border-bottom: 1px solid #dfe4e8;
    cursor: pointer;

    select {
      font-size: ${props => props.theme.textAppearances.copy200.fontSize};
      font-family: ${props => props.theme.textAppearances.copy200.fontFamily};
      line-height: ${props => props.theme.textAppearances.copy200.lineHeight};
      color: #001e50;
      position: relative;
      cursor: pointer;
      appearance: none;
      background: none;
      border: none;
      opacity: 1;
      z-index: 1;
      width: 100%;

      &:focus {
        outline: none;
      }
    }

    &:hover {
      color: #0040c5;

      select {
        color: #0040c5;
      }

      option {
        color: #000000;
      }
    }
  }
`
  
export const LabelContainer = styled.div`
  margin: 20px 0 -5px;
  
  &.reduce {
      margin-bottom: -15px;
  }

  p {
      font-size: ${props => props.theme.textAppearances.copy100.fontSize};
      font-family: ${props => props.theme.textAppearances.copy100.fontFamily};
      line-height: ${props => props.theme.textAppearances.copy100.lineHeight};
      color: #001E50;
  }
`;
  
export const IconContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
  z-index: 0;

  svg {
    position: absolute;
    top: 0;
    right: 0;
  }
`

export const ErrorContainer = styled.div`
  width: 100%;

  p {
    color: red;
    margin-bottom: -15px;
  }
`
